import { useState } from 'react';
import SEO from '../../components/SEO';
import Hero from './components/Hero';
import WhyNeed from './components/WhyNeed';
import WhatDoing from './components/WhatDoing';
import Difference from './components/Difference';
import WhatIncluded from './components/WhatIncluded';
import WhoIsFor from './components/WhoIsFor';
import NextStep from './components/NextStep';
import Footer from './components/Footer';
import ContactForm from '../home/components/ContactForm';

export default function AnnualPlanPage() {
  const [isFormOpen, setIsFormOpen] = useState(false);

  const handleOpenForm = () => {
    setIsFormOpen(true);
  };

  const handleCloseForm = () => {
    setIsFormOpen(false);
  };

  const schemaData = {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": "網站年度維護管理方案",
    "description": "提供全方位的網站年度維護服務，包含技術支援、內容更新、安全監控、效能優化等專業服務，確保您的網站持續穩定運作。",
    "provider": {
      "@type": "Organization",
      "name": "行曜科技",
      "url": import.meta.env.VITE_SITE_URL || "https://example.com"
    },
    "areaServed": "TW",
    "serviceType": "網站維護管理",
    "offers": {
      "@type": "Offer",
      "name": "年度維護方案",
      "description": "全年無休的網站維護服務，包含定期更新、安全監控、技術支援等",
      "priceCurrency": "TWD"
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="網站年度維護管理方案 | 專業網站維護服務"
        description="提供全方位的網站年度維護服務，包含技術支援、內容更新、安全監控、效能優化等專業服務，確保您的網站持續穩定運作。"
        keywords="網站維護,年度維護,網站管理,技術支援,網站更新,安全監控,效能優化"
        canonical="/annual-plan"
        schemaData={schemaData}
      />
      <Hero />
      <WhyNeed />
      <WhatDoing />
      <Difference />
      <WhatIncluded />
      <WhoIsFor />
      <NextStep onOpenForm={handleOpenForm} />
      <Footer onOpenForm={handleOpenForm} />
      <ContactForm isOpen={isFormOpen} onClose={handleCloseForm} />
    </div>
  );
}
